module.exports = __webpack_public_path__ + "static/media/profile-pic.76d01608.png";